import {
  BOOKS_BOOK_CITATIONS_RESET_DATA,
  BOOKS_BOOK_CITATIONS_SET_DATA,
} from 'rebook/apps/books/constants';


const initialState = {
  book: null,
  citations: null,
  pageNumber: 1,
  lastPageNumber: 0,
};

export default function bookCitationList(state = initialState, action) {
  switch (action.type) {
    case BOOKS_BOOK_CITATIONS_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case BOOKS_BOOK_CITATIONS_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
